import { Box } from "@chakra-ui/react";

import Attributes from "@/user/components/UserAttributes";

export function UserAttributes() {
  return (
    <Box px={6} py={6}>
      <Attributes />
    </Box>
  );
}
